import React from 'react';
import { motion } from 'framer-motion';
export function PhilosophySection() {
  const doctrines = ['You do not rise to the level of your goals. You fall to the level of your discipline.', 'Vision without execution is delusion.', 'Pressure reveals character.', 'Consistency creates leverage.', 'Leaders are not born. They are FORGED.'];
  return <section id="philosophy" className="py-32 px-6 bg-[var(--forge-black)] relative overflow-hidden" data-id="element-85">
      {/* Diagonal accent line */}
      <div className="absolute top-0 right-0 w-1/2 h-px bg-gradient-to-l from-[var(--forge-lava)] to-transparent" data-id="element-86" />
      <div className="absolute bottom-0 left-0 w-1/2 h-px bg-gradient-to-r from-[var(--forge-lava)] to-transparent" data-id="element-87" />

      <div className="max-w-5xl mx-auto" data-id="element-88">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-20" data-id="element-89">
          <h2 className="text-5xl md:text-6xl font-black tracking-tighter mb-4" data-id="element-90">
            THE FORGE <span className="text-[var(--forge-lava)]" data-id="element-91">DOCTRINE</span>
          </h2>
        </motion.div>

        <div className="space-y-12" data-id="element-92">
          {doctrines.map((doctrine, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: index % 2 === 0 ? -30 : 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: index * 0.1
        }} className="relative" data-id="element-93">
              <div className="flex items-start gap-6" data-id="element-94">
                <div className="flex-shrink-0 w-12 h-12 bg-[var(--forge-lava)] flex items-center justify-center font-black text-xl" data-id="element-95">
                  {index + 1}
                </div>
                <p className="text-2xl md:text-3xl font-bold leading-relaxed text-[var(--forge-white)]" data-id="element-96">
                  {doctrine}
                </p>
              </div>
              {index < doctrines.length - 1 && <div className="ml-6 mt-6 w-px h-8 bg-gradient-to-b from-[var(--forge-lava)] to-transparent" data-id="element-97" />}
            </motion.div>)}
        </div>
      </div>
    </section>;
}